document.addEventListener('DOMContentLoaded', () => {
  if (typeof WOW === 'function') {
    new WOW().init();
  }
});
